"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISSUES_ENTITY_TYPE = exports.ISSUES_DOMAIN = void 0;
const ISSUES_DOMAIN = exports.ISSUES_DOMAIN = "autodesk-bim360-issue";
const ISSUES_ENTITY_TYPE = exports.ISSUES_ENTITY_TYPE = "issue";
//# sourceMappingURL=relationships.js.map